export default __webpack_public_path__ + "static/155-min-min-94f087b9e1b11215e841b5471cb4d33f.jpg";